import Record from "./base"

export default class Discount extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
